module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/sara_smile-235bfd423fca04d38d1338973d9baaa5.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/sara_smile.png
// module id = 2383
// module chunks = 2